var _div;
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';

/**
 * This component is used to wrap content that may be fetched asynchronously.
 * It does not handle the fetching but purely is a standardized method to display an indicator
 * during an async action. Based on the boolean of the renderChildren flag the supplied children
 * may be rendered or replaced with a spinning version of either the standard or supplied glyphicon.
 *
 */
import { jsx as _jsx } from "react/jsx-runtime";
function AjaxSpinner(_ref) {
  let {
    renderChildren = false,
    children,
    spinnerClassName,
    ...rest
  } = _ref;
  const rootClassName = clsx(spinnerClassName, 'ajax-spinner');
  const spinner = /*#__PURE__*/_jsx("div", {
    "data-cmp": "ajaxSpinner",
    className: rootClassName,
    children: _div || (_div = /*#__PURE__*/_jsx("div", {
      className: "spinner"
    }))
  });
  return /*#__PURE__*/_jsx("div", {
    ...rest,
    children: renderChildren ? children : spinner
  });
}
export default AjaxSpinner;